import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-spatials'

import {
  TREE,
  BRANCH,
} from 'fc-spatial'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import { composeFetchSaga } from 'fc-fetch-worker'

// WebWorker
import worker from 'fc-wrkr-spatials'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize: function initialize (controller) {
    const terminate = function terminate () {
      if (worker) {
        worker.terminate()
      }
    }

    return new Promise((resolve) => {
      terminate()

      resolve({
        terminate,
        handleFetch: composeFetchSaga({
          getWorker: function () {
            return worker.getWorker()
          },
        }),
      })
    })
  },
})
